import React from "react";
import "./EndingBody.css";

const EndingBody = () => {
  return (
    <React.Fragment>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          alignContent: "center",
          justifyContent: "center",
          flexFlow: "wrap",
        }}
      >
        <h2
          className="blue-ending-rectangle font-face-poppins-bold"
          style={{ fontSize: "50px" }}
        >
          ¡Gracias
        </h2>
        <h2
          className="blue-font font-face-poppins-bold"
          style={{
            fontSize: "50px",
            marginLeft: "10px",
          }}
        >
          por completar la solicitud!
        </h2>
      </div>
    </React.Fragment>
  );
};

export default EndingBody;
